{
  "accountHealth": "صحة الحساب",
  "activeCopies": "النسخ النشطة",
  "addFavorite": "☆ إضافة للمفضلة",
  "affectedCoins": "العملات المتأثرة",
  "aiAlert": "تنبيه AI",
  "aiArbitrageScanner": "ماسح المراجحة الذكي",
  "aiCenter": "مركز الذكاء الاصطناعي",
  "aiConfidence": "ثقة AI",
  "aiConfidenceMeter": "مقياس ثقة AI",
  "aiCopyTrading": "نسخ التداول بالذكاء الاصطناعي",
  "aiFinalDecision": "قرار AI النهائي",
  "aiGridTrading": "تداول الشبكة الذكي",
  "aiLaunchpad": "منصة الإطلاق بالذكاء الاصطناعي",
  "aiMarketNews": "أخبار السوق من AI",
  "aiMarketScanner": "ماسح السوق الذكي",
  "aiNews": "أخبار الذكاء الاصطناعي",
  "aiPortfolioManager": "مدير المحفظة الذكي",
  "aiProfitCalculator": "حاسبة الأرباح الذكية",
  "aiRankedTrader": "متداول مصنّف بواسطة AI",
  "aiRebalance": "إعادة توازن AI",
  "aiRecommendation": "توصية الذكاء الاصطناعي",
  "aiRecommendations": "توصيات AI",
  "aiResult": "نتيجة AI",
  "aiRiskEngine": "محرك مخاطر AI",
  "aiRiskLevel": "مستوى مخاطر AI",
  "aiRiskManager": "مدير المخاطر الذكي",
  "aiScanResult": "نتيجة فحص AI",
  "aiScore": "نقاط AI",
  "aiSignal": "إشارة AI",
  "aiSmartAlerts": "تنبيهات ذكية",
  "aiSubtitle": "تداول وتحليلات وأتمتة وإدارة مخاطر مدعومة بالذكاء الاصطناعي.",
  "aiSuggestions": "اقتراحات الذكاء الاصطناعي",
  "aiTitle": "الذكاء الاصطناعي",
  "aiTrader": "متداول AI",
  "aiTradingAssistant": "مساعد التداول الذكي",
  "aiTradingAssistantSubtitle": "إشارات السوق وتحليل المشاعر والاتجاهات من AI في الوقت الفعلي.",
  "aiTrustScore": "درجة الثقة الذكية",
  "aiWhaleAlerts": "تنبيهات الحيتان بالذكاء الاصطناعي",
  "aiWhaleHeatmap": "خريطة الحيتان الحرارية بالذكاء الاصطناعي",
  "aiWhaleTracker": "متتبع الحيتان الذكي",
  "alertType": "نوع التنبيه",
  "allCategories": "جميع الفئات",
  "allImpact": "جميع التأثيرات",
  "allImpacts": "جميع التأثيرات",
  "allSentiments": "جميع المشاعر",
  "allSymbols": "جميع الرموز",
  "apply": "تطبيق",
  "applySafeModeScan": "تطبيق فحص الوضع الآمن",
  "applying": "جارٍ التطبيق...",
  "arbitrageOpportunities": "فرص المراجحة",
  "assetAllocation": "توزيع الأصول",
  "audit": "تدقيق",
  "backendPreviewAlerts": "تُعرض التنبيهات هنا معاينة قبل حفظها.",
  "backendWillSaveAfterApi": "سيتم حفظ هذا بعد تأكيد الخادم للطلب.",
  "baseCoin": "العملة الأساسية",
  "breaking": "عاجل",
  "btcDominance": "هيمنة BTC",
  "btcVolatilityNews": "أخبار تقلبات BTC",
  "buyDecision": "شراء",
  "buyExchange": "منصة الشراء",
  "buyPressure": "ضغط الشراء",
  "buyPrice": "سعر الشراء",
  "buySignal": "شراء",
  "buyStrength": "قوة الشراء",
  "buyVolume": "حجم الشراء",
  "buyZone": "منطقة الشراء",
  "calculate": "احسب",
  "calculateAiProfit": "حساب ربح AI",
  "calculating": "جارٍ الحساب...",
  "capitalGreaterThanZero": "يجب أن يكون رأس المال أكبر من صفر.",
  "capitalProtection": "حماية رأس المال",
  "category": "الفئة",
  "clear": "مسح",
  "communityScore": "نقاط المجتمع",
  "compoundDays": "أيام المضاعفة",
  "compoundResult": "نتيجة المضاعفة",
  "condition": "الشرط",
  "confidence": "الثقة",
  "confidenceScore": "درجة الثقة",
  "contractSafety": "أمان العقد",
  "copyTradeIdMissing": "معرّف صفقة النسخ مفقود.",
  "copyTrader": "نسخ المتداول",
  "copyTradingStarted": "بدأ النسخ التلقائي للتداول.",
  "copyTradingStopped": "توقف النسخ التلقائي للتداول.",
  "createAiAlert": "إنشاء تنبيه AI",
  "createAiOpportunity": "إنشاء فرصة AI",
  "createAiWhaleAlert": "إنشاء تنبيه حيتان AI",
  "createGridStrategy": "إنشاء استراتيجية شبكية",
  "createLaunchpadProject": "إنشاء مشروع Launchpad",
  "createOpportunity": "إنشاء فرصة",
  "createSmartAlert": "إنشاء تنبيه ذكي",
  "createWhaleAlert": "إنشاء تنبيه حيتان",
  "created": "تم الإنشاء",
  "creating": "جارٍ الإنشاء...",
  "currentPrice": "السعر الحالي",
  "currentRiskScore": "نقاط المخاطر الحالية",
  "dailyProfit": "الربح اليومي",
  "delete": "حذف",
  "deleteCalculationConfirm": "هل أنت متأكد من رغبتك في حذف هذا الحساب؟",
  "deleteMarketScanConfirm": "هل أنت متأكد من رغبتك في حذف فحص السوق هذا؟",
  "detected": "تم الكشف",
  "diversification": "التنويع",
  "emailAlert": "تنبيه بريد إلكتروني",
  "enableCompoundingProjection": "تفعيل توقع الفائدة المركبة",
  "enterCopyAmountFor": "أدخل مبلغ النسخ لـ",
  "enterNewsTitle": "أدخل عنوان الخبر",
  "exitPrice": "سعر الخروج",
  "expectedLoss": "الخسارة المتوقعة",
  "expectedProfit": "الربح المتوقع",
  "extremeFear": "خوف شديد",
  "extremeGreed": "طمع شديد",
  "failedCalculateProfit": "فشل حساب الربح.",
  "failedCreateArbitrageOpportunity": "فشل إنشاء فرصة المراجحة.",
  "failedCreateGridStrategy": "فشل إنشاء الاستراتيجية الشبكية.",
  "failedCreateLaunchpadProject": "فشل إنشاء مشروع Launchpad.",
  "failedCreateSmartAlert": "فشل إنشاء التنبيه الذكي.",
  "failedDeleteCalculation": "فشل حذف الحساب.",
  "failedDeleteMarketScan": "فشل حذف فحص السوق.",
  "failedLoadAiNews": "فشل تحميل أخبار AI.",
  "failedLoadArbitrageScanner": "فشل تحميل ماسح المراجحة.",
  "failedLoadGridTrading": "فشل تحميل التداول الشبكي.",
  "failedLoadLaunchpad": "فشل تحميل Launchpad.",
  "failedLoadMarketScanner": "فشل تحميل ماسح السوق.",
  "failedLoadProfitCalculator": "فشل تحميل حاسبة الأرباح.",
  "failedLoadRiskManager": "فشل تحميل مدير المخاطر.",
  "failedLoadSmartAlerts": "فشل تحميل التنبيهات الذكية.",
  "failedLoadTrustScore": "فشل تحميل نقاط الثقة.",
  "failedLoadWhaleHeatmap": "فشل تحميل خريطة حرارة الحيتان.",
  "failedLoadWhaleTracker": "فشل تحميل متتبع الحيتان.",
  "failedLogins": "محاولات دخول فاشلة",
  "failedMarkAlertRead": "فشل تحديد التنبيه كمقروء.",
  "failedNewsAction": "فشل إتمام هذا الإجراء.",
  "failedRefreshRiskProfile": "فشل تحديث ملف المخاطر.",
  "failedRunMarketScan": "فشل تشغيل فحص السوق.",
  "failedStartCopyTrading": "فشل بدء النسخ التلقائي.",
  "failedStopCopyTrading": "فشل إيقاف النسخ التلقائي.",
  "failedSubmitNews": "فشل إرسال الخبر.",
  "failedSyncSymbol": "فشل مزامنة الرمز.",
  "failedToLoadData": "فشل تحميل بيانات الذكاء الاصطناعي.",
  "failedUpdateFavorite": "فشل تحديث المفضلة.",
  "favorite": "★ مفضل",
  "fear": "خوف",
  "fearGreedGauge": "مقياس الخوف والطمع",
  "fearGreedIndex": "مؤشر الخوف والطمع",
  "featuredLaunch": "إطلاق مميز",
  "generate": "إنشاء",
  "generateAiGrid": "توليد شبكة AI",
  "generating": "جارٍ التوليد...",
  "greed": "طمع",
  "gridCount": "عدد الشبكات",
  "gridStrategies": "استراتيجيات شبكية",
  "grids": "الشبكات",
  "hardCap": "الحد الأقصى الصلب",
  "heat": "الحرارة",
  "high": "مرتفع",
  "highPriority": "أولوية عالية",
  "highRisk": "مخاطر عالية",
  "highRiskDetected": "تم الكشف عن مخاطر عالية.",
  "highWithdrawals": "سحوبات مرتفعة",
  "holderScore": "درجة الحاملين",
  "impact": "التأثير",
  "investment": "الاستثمار",
  "kycCompleted": "تم إكمال KYC",
  "lastScan": "آخر فحص",
  "lastUpdated": "آخر تحديث",
  "latestAlert": "أحدث تنبيه",
  "launchpadProjects": "مشاريع Launchpad",
  "liquidityScore": "درجة السيولة",
  "liveAiMarketSignal": "إشارة سوق AI المباشرة",
  "liveVolume": "الحجم المباشر",
  "liveWhaleAlerts": "تنبيهات الحيتان المباشرة",
  "loading": "جاري التحميل...",
  "loadingAi": "جارٍ تحميل بيانات الذكاء الاصطناعي...",
  "loadingAiNews": "جارٍ تحميل أخبار AI...",
  "loadingArbitrageScanner": "جارٍ تحميل ماسح المراجحة...",
  "loadingGridTrading": "جارٍ تحميل التداول الشبكي...",
  "loadingLaunchpad": "جارٍ تحميل Launchpad...",
  "loadingMarketScanner": "جارٍ تحميل ماسح السوق...",
  "loadingProfitCalculator": "جارٍ تحميل حاسبة الأرباح...",
  "loadingRiskManager": "جارٍ تحميل مدير المخاطر...",
  "loadingSmartAlerts": "جارٍ تحميل التنبيهات الذكية...",
  "loadingTrustScore": "جارٍ تحميل نقاط الثقة...",
  "loadingWhaleAlerts": "جارٍ تحميل تنبيهات الحيتان...",
  "loadingWhaleHeatmap": "جارٍ تحميل خريطة حرارة الحيتان...",
  "loadingWhaleTracker": "جارٍ تحميل متتبع الحيتان...",
  "lowRisk": "مخاطر منخفضة",
  "lowRiskDetected": "تم الكشف عن مخاطر منخفضة.",
  "lowerPrice": "السعر الأدنى",
  "markRead": "تحديد كمقروء",
  "marketSentiment": "معنويات السوق",
  "marketType": "نوع السوق",
  "marketWeaknessDetected": "تم الكشف عن ضعف في السوق.",
  "maxBuy": "الحد الأقصى للشراء",
  "medium": "متوسط",
  "mediumRisk": "مخاطرة متوسطة",
  "mediumRiskDetected": "تم الكشف عن مخاطر متوسطة.",
  "minBuy": "الحد الأدنى للشراء",
  "minimumWhaleAmountUsd": "الحد الأدنى لمبلغ الحوت (دولار)",
  "moderateTrend": "اتجاه معتدل",
  "monthlyProfit": "الربح الشهري",
  "myCopyTrades": "صفقات النسخ الخاصة بي",
  "myMarketScanHistory": "سجل فحص السوق الخاص بي",
  "myProfitHistory": "سجل الأرباح الخاص بي",
  "neutralDecision": "محايد",
  "neutralMarketConditions": "ظروف سوق محايدة.",
  "neutralSignal": "محايد",
  "newsFeed": "موجز الأخبار",
  "noActiveCopyTrades": "لا توجد صفقات نسخ نشطة.",
  "noAiNewsFound": "لم يتم العثور على أخبار AI.",
  "noAlertsFound": "لم يتم العثور على تنبيهات.",
  "noCalculationYet": "لا يوجد حساب بعد.",
  "noDate": "لا يوجد تاريخ",
  "noGridStrategiesFound": "لم يتم العثور على استراتيجيات شبكية.",
  "noHeatmapDataFound": "لم يتم العثور على بيانات خريطة الحرارة.",
  "noLaunchpadProjectsFound": "لم يتم العثور على مشاريع Launchpad.",
  "noOpportunitiesFound": "لم يتم العثور على فرص.",
  "noPinnedNews": "لا توجد أخبار مثبتة.",
  "noRecommendationYet": "لا توجد توصية بعد.",
  "noRiskHistoryYet": "لا يوجد سجل مخاطر بعد.",
  "noSavedCalculations": "لا توجد حسابات محفوظة.",
  "noSavedScans": "لا توجد عمليات فحص محفوظة.",
  "noScanYet": "لا يوجد فحص بعد.",
  "noTrustScoresFound": "لم يتم العثور على نقاط ثقة.",
  "noWhaleTransactionsFound": "لم يتم العثور على معاملات حيتان.",
  "noWhaleWalletsDetected": "لم يتم الكشف عن محافظ حيتان.",
  "notScannedYet": "لم يتم الفحص بعد.",
  "p2pDisputes": "نزاعات P2P",
  "pinned": "مثبّت",
  "pinnedNews": "الأخبار المثبتة",
  "portfolioExposure": "تعرض المحفظة",
  "portfolioRebalancedSuccessfully": "تمت إعادة موازنة المحفظة بنجاح.",
  "position": "المركز",
  "priority": "الأولوية",
  "processing": "جاري المعالجة...",
  "projectName": "اسم المشروع",
  "raised": "تم جمعه",
  "raisedAmount": "المبلغ المُجمّع",
  "rebalanceFailed": "فشلت إعادة التوازن.",
  "records": "السجلات",
  "refresh": "تحديث",
  "refreshAiScan": "تحديث فحص الذكاء الاصطناعي",
  "risk": "المخاطر",
  "riskFactors": "عوامل المخاطر",
  "riskHistory": "سجل المخاطر",
  "riskLevel": "مستوى المخاطر",
  "riskReward": "المخاطرة / العائد",
  "riskRewardRatio": "نسبة المخاطرة إلى العائد",
  "riskScore": "درجة المخاطر",
  "roi": "ROI",
  "runAiMarketScan": "تشغيل فحص سوق AI",
  "runAiScan": "تشغيل فحص ذكي",
  "safe": "آمن",
  "scan": "فحص",
  "scanning": "جارٍ الفحص...",
  "searchAiNews": "البحث في أخبار AI...",
  "searchWalletOrSymbol": "البحث عن محفظة أو رمز...",
  "sellDecision": "بيع",
  "sellExchange": "منصة البيع",
  "sellPressure": "ضغط البيع",
  "sellPrice": "سعر البيع",
  "sellSignal": "بيع",
  "sellVolume": "حجم البيع",
  "sellZone": "منطقة البيع",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "signal": "الإشارة",
  "signalStrength": "قوة الإشارة",
  "smartAlerts": "التنبيهات الذكية",
  "softCap": "الحد الأدنى المرن",
  "source": "المصدر",
  "sourceUrl": "رابط المصدر",
  "spread": "الفارق السعري",
  "stop": "إيقاف",
  "strongBuyDecision": "شراء قوي",
  "strongBuyOpportunity": "فرصة شراء قوية.",
  "strongTrend": "اتجاه قوي",
  "submitAiNews": "إرسال خبر AI",
  "submitNews": "إرسال خبر",
  "submitNewsForAiAnalysis": "إرسال خبر لتحليل AI.",
  "suggestedCopy": "مبلغ النسخ المقترح",
  "suggestedLeverage": "الرافعة المالية المقترحة",
  "summary": "الملخص",
  "suspiciousActivity": "نشاط مشبوه",
  "sync": "مزامنة",
  "syncing": "جارٍ المزامنة...",
  "targetPrice": "السعر المستهدف",
  "telegramAlert": "تنبيه تيليجرام",
  "timeframe": "الإطار الزمني",
  "title": "العنوان",
  "titleSummaryRequired": "العنوان والملخص مطلوبان.",
  "tokenPrice": "سعر التوكن",
  "topGainers": "الأكثر ارتفاعاً",
  "topGridStrategy": "أفضل استراتيجية شبكية",
  "topLosers": "الأكثر انخفاضاً",
  "topOpportunity": "أفضل فرصة",
  "topWhaleWallets": "أفضل محافظ الحيتان",
  "totalAlerts": "إجمالي التنبيهات",
  "totalCopied": "إجمالي المنسوخ",
  "totalNews": "إجمالي الأخبار",
  "totalPL": "إجمالي الربح/الخسارة",
  "totalValue": "القيمة الإجمالية",
  "totalWhaleVolume": "إجمالي حجم الحيتان",
  "tradeSetup": "إعداد الصفقة",
  "transferVolume": "حجم التحويل",
  "trend": "الاتجاه",
  "trendStrength": "قوة الاتجاه",
  "upperPrice": "السعر الأعلى",
  "usdValue": "القيمة بالدولار",
  "viewDetails": "عرض التفاصيل",
  "volatility": "التقلب",
  "volatilityIndex": "مؤشر التقلب",
  "weakTrend": "اتجاه ضعيف",
  "whaleAccumulation": "تراكم الحيتان",
  "whaleActivity": "نشاط الحيتان",
  "whaleAlertCreatedFor": "تم إنشاء تنبيه الحوت لـ",
  "whaleRisk": "مخاطر الحيتان",
  "whaleScore": "نقاط الحوت",
  "writeNewsSummary": "اكتب ملخص الخبر",
  "yearlyProfit": "الربح السنوي"
}